import ThemeContext from "config/context/themeContext";
import { Children, isValidElement, useContext } from "react";
import styles from "./Select.module.css";

/**
 * Padajući izbor koji NE SME da prikaže ono što nema.
 *
 * `<select>` čija `value` ne pogađa nijednu opciju prikazuje PRVU, i to bez
 * ijednog upozorenja. Stanje je prazno, a korisnik vidi uredno ime i veruje da
 * je izabrano. Tako je 25.08. baza izgledala izabrano dok je aplikacija slala
 * `database: ""` — kvar se ispoljio tek dva koraka kasnije, kao odbijen uvoz sa
 * porukom o polju koje korisnik nije ni popunjavao.
 *
 * Zato se neslaganje prikazuje umesto da se ćuti: kad `value` ne postoji među
 * opcijama, stoji `— none selected —`. Greška time postaje vidljiva tamo gde
 * nastaje, a ne tri ekrana dalje.
 */
const Select = ({
  value,
  onChange,
  children,
  className,
  placeholder = "— none selected —",
  ...props
}) => {
  const { dark } = useContext(ThemeContext);

  // Poređenje preko `String` jer opcije mogu nositi i brojeve; `undefined` i
  // `null` se svode na prazan string, inače bi `<select>` postao nekontrolisan.
  const current = value === undefined || value === null ? "" : String(value);
  const matches = Children.toArray(children).some(
    (child) => isValidElement(child) && String(child.props?.value) === current,
  );

  return (
    <select
      value={matches ? current : ""}
      onChange={onChange}
      className={`${styles.select} ${dark ? styles.dark : ""} ${
        className ?? ""
      }`}
      {...props}
    >
      {!matches && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {children}
    </select>
  );
};

export default Select;
